import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import * as dxlist from '../../assets/tables/cardio_dx_search.json';
import { ExamsService } from '../exams.service';

const MAX_RESULTS = 30;

@Component({
  selector: 'app-dx-search',
  templateUrl: './dx-search.component.html',
  styleUrls: ['./dx-search.component.scss'],
  standalone: false
})
export class DxSearchComponent {

  @Input('control') control: AbstractControl;
  @Input('placeholder') placeholder = 'Search diagnosis by code';

  query = '';
  entries: string[][] = dxlist['default'];

  constructor(public es: ExamsService) { }

  get results(): string[][] {
    const tokens = this.query.trim().toLowerCase().split(/\s+/).filter(t => t);
    if (!tokens.length)
      return [];
    const matches = this.entries.filter(e => this.matches(e, tokens));
    const exact = tokens.length === 1 ? tokens[0] : null;
    matches.sort((a, b) => Number(b[0].toLowerCase() === exact && !b[1]) - Number(a[0].toLowerCase() === exact && !a[1]));
    return matches.slice(0, MAX_RESULTS);
  }

  private matches(entry: string[], tokens: string[]): boolean {
    const base = entry[0].toLowerCase();
    const sev = entry[1].toLowerCase();
    const keys = [base, sev, base + sev].filter(k => k);
    const compact = tokens.join('');
    if (base + sev !== '' && (base + sev).startsWith(compact))
      return true;
    return tokens.every(t => keys.some(k => k.startsWith(t)));
  }

  add(text: string) {
    if (this.es.isClosed || !this.control)
      return;
    const current: string = this.control.value || '';
    const separator = !current || current.endsWith('\n') ? '' : '\n';
    this.control.setValue(current + separator + text);
    this.control.markAsDirty();
    this.query = '';
  }

  addFirst() {
    const first = this.results[0];
    if (first)
      this.add(first[2]);
  }
}
